export const ADMIN_SCORE_FETCH_ALL = 'ADMIN_SCORE_FETCH_ALL';
export const ADMIN_SCORE_FETCH_ALL_SUCCESS = 'ADMIN_SCORE_FETCH_ALL_SUCCESS';
export const ADMIN_SCORE_FETCH_ALL_FAIL = 'ADMIN_SCORE_FETCH_ALL_FAIL';
export const ADMIN_SCORE_FETCH = 'ADMIN_SCORE_FETCH';
export const ADMIN_SCORE_FETCH_SUCCESS = 'ADMIN_SCORE_FETCH_SUCCESS';
export const ADMIN_SCORE_FETCH_FAIL = 'ADMIN_SCORE_FETCH_FAIL';
export const ADMIN_SCORE_UPDATE = 'ADMIN_SCORE_UPDATE';
export const ADMIN_SCORE_UPDATE_SUCCESS = 'ADMIN_SCORE_UPDATE_SUCCESS';
export const ADMIN_SCORE_UPDATE_FAIL = 'ADMIN_SCORE_UPDATE_FAIL';
export const ADMIN_SCORE_SET_SORT = 'ADMIN_SCORE_SET_SORT';
